import React, {useEffect} from 'react'
import HeadingSection from './HeadingSection/HeadingSection'
import "./Campaign.css"
import CreateCampaignBtn from './CreateCampaignBtn/CreateCampaignBtn'
import UserCampaign from './UserCampaign/UserCampaign'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllCampaignDetails } from '../../store/campaigns-slice'
import NoCampaignImg from "../../assets/images/no-campaign.svg" 

const Campaign = () => {
  const user = useSelector(state =>state?.user?.user)
  const campaignDetail = useSelector(state => state.campaigns.data)
  const homePageProfile = useSelector(state => state.homePageProfile.data)

  const dispatch = useDispatch()

  useEffect(() => {
    console.log(user?.app_business_id, "APP BUSINESS ID")
    if (user?.app_business_id){
    dispatch(fetchAllCampaignDetails({
        businessId: user?.app_business_id,
        status: ["ALL"],
        request_page: ["homepage", "myads"]
    }))
  }
}, [user?.app_business_id])

  return (
    <div id='campaign'>
      {!campaignDetail?.length && 
        <div className='noCampaign'>
          <img src={NoCampaignImg} />
          <h2>No campaign</h2>
          <p className='sub'>Please run a campaign to get messages from customers and manage all in one go</p>
          <CreateCampaignBtn  url='/create-campaign' text="Create new Campaign" />
        </div>
      }
      {campaignDetail?.length !==0 && 
      <>
        <div className="c-section">
            <HeadingSection heading="Your Campaigns" />
            <CreateCampaignBtn  url='/create-campaign' text="Create new Campaign" />
        </div>
        <UserCampaign campaigns={campaignDetail} campaignsSection />
        </>}
    </div>
  )
}

export default Campaign